import React from 'react';
import {
    Checkbox,
    Grid,
    Typography,
} from "@mui/material";
import {FieldSearchContainerValue} from "../../../services/grace";
import LookupPicker, {LookupPickerProps} from "../LookupPicker/LookupPicker";

export interface CartonPickerProps {
    label?: string;
    enableOpenFile: boolean;
}

export default (props: CartonPickerProps & Omit<LookupPickerProps<FieldSearchContainerValue>, "label" | "isOptionEqualToValue">): JSX.Element => {
    const { label = "Carton", onChange, disabled, enableOpenFile, value, ...rest } = props;

    const handleCheckbox = (event: React.ChangeEvent<HTMLInputElement>) => {
        const openFileValue = { id: "OPENFILE", barcode: "OPENFILE", altCode: "" };

        onChange(event, value !== null && value.id === "OPENFILE" ? null : openFileValue);
    }

    return (
        <Grid container item>
            <Grid item xs={9}>
                <LookupPicker<FieldSearchContainerValue>
                    label={label}
                    isOptionEqualToValue={(option: FieldSearchContainerValue, value: FieldSearchContainerValue) => option.id === value.id}
                    onChange={onChange}
                    disabled={disabled || (value !== null && value.id === "OPENFILE")}
                    value={value}
                    {...rest}
                />
            </Grid>
            {enableOpenFile &&
                <Grid item xs={3} sx={{alignContent: "center"}}>
                    <Typography variant="subtitle2" align="center" sx={{opacity: disabled ? 0.38 : 1}}>Open file</Typography>
                    <Checkbox
                        name="permanent"
                        color="secondary"
                        checked={value !== null && value.id === "OPENFILE"}
                        onChange={handleCheckbox}
                        disabled={disabled}
                        sx={{width: "100%"}}
                    />
                </Grid>
            }
        </Grid>
    )
}
